/** Who can open this project: the owner shares it with other accounts to edit. */

import { UserPlus, X } from "lucide-react";
import { useEffect, useState } from "react";
import { api, type Member } from "../api";
import { useEditor } from "./store";

export function PeopleDialog() {
  const project = useEditor((s) => s.project)!;
  const [members, setMembers] = useState<Member[] | null>(null);
  const [me, setMe] = useState<string | null>(null);
  const [email, setEmail] = useState("");
  const [err, setErr] = useState("");
  const close = () => useEditor.getState().set({ panel: null });
  const owner = members?.some((m) => m.role === "owner" && m.id === me);

  useEffect(() => {
    api.members(project.id).then(setMembers).catch((e) => setErr(e.message));
    api.session().then((s) => setMe(s.user?.id ?? null)).catch(() => {});
  }, [project.id]);

  const act = async (fn: () => Promise<unknown>) => {
    setErr("");
    try {
      await fn();
      setMembers(await api.members(project.id));
    } catch (e) {
      setErr((e as Error).message);
    }
  };
  const add = (e: React.FormEvent) => {
    e.preventDefault();
    void act(async () => {
      await api.addMember(project.id, email.trim());
      setEmail("");
    });
  };

  return (
    <div className="modal-back" onPointerDown={close}>
      <div className="modal people-dialog" onPointerDown={(e) => e.stopPropagation()}>
        <header>
          <h3>People</h3>
          <button className="icon" onClick={close}><X size={18} /></button>
        </header>
        <p className="muted small">
          People listed here can open and edit this project. Only the owner can add or remove people or delete the project. To show finished videos to someone
          without an account, use a review link instead.
        </p>
        <table className="people">
          <tbody>
            {members?.map((m) => (
              <tr key={m.id}>
                <td>{m.name}{m.id === me ? " (you)" : ""}<div className="muted small">{m.email}</div></td>
                <td className="muted small">{m.role === "owner" ? "Owner" : "Can edit"}</td>
                <td className="actions">
                  {m.role === "editor" && owner && <button onClick={() => act(() => api.removeMember(project.id, m.id))}>Remove</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {owner && (
          <form onSubmit={add} className="invite-form">
            <input type="email" autoFocus placeholder="Share with (their account email)" value={email} onChange={(e) => setEmail(e.target.value)} />
            <button className="primary" disabled={!email.trim()}><UserPlus size={15} /> Share</button>
          </form>
        )}
        {err && <p className="bad small">{err}</p>}
      </div>
    </div>
  );
}
